import styled from '@emotion/styled'

export const ImportedInvoicesPeriodSelector = styled.div`
  margin-left: auto;
`
